import { Box, SystemStyleObject, Text } from "@chakra-ui/react";

type IProps = {
  sx?: SystemStyleObject | undefined;
};

export const OrSperator = (props: IProps) => {
  return (
    <Box sx={props.sx}>
      <Text
        fontWeight={600}
        fontSize={"bodyTiny"}
        fontFamily={"header"}
        textAlign={"center"}
        color={"neutral400"}
        _dark={{ color: "neutral200" }}
      >
        OR
      </Text>
    </Box>
  );
};
